import TopicTwo from "../../resource-contents/trading-calculator-contents/TopicTwo";

const TradingCalculatorContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Built for Traders Who Value Accuracy</h1>
            <p>Plan your next trade with exact numbers, not assumptions.</p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Comprehensive Metrics</h4>
                </div>
                <p>
                  Calculate profit, margin, swap, and pip value all in one
                  place. No manual formulas needed.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Real-Time Market Rates</h4>
                </div>
                <p>
                  The calculator uses live data feeds to ensure every
                  calculation reflects current market prices.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Universal Accessibility</h4>
                </div>
                <p>
                  Access the calculator on any device; desktop, tablet, or
                  mobile and get the same seamless experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TradingCalculatorContentFive;
